import React, { type ComponentType, type ReactElement } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useRouter } from '@atlassian/jira-router';

type RedirectFunction = (page: string, plan?: { planId: string; scenarioId: string }) => void;

type RedirectProps = {
	redirectToSpaPlanPage: RedirectFunction;
};

export const useRedirectToSpaPlanPage = (): RedirectFunction => {
	const [{ match, location }, { replace }] = useRouter();
	return (page: string, plan?: { planId: string; scenarioId: string }) => {
		if (!match.params?.planId || !match.params?.scenarioId) return;

		const newUrl =
			ff('jet-plans-nav-refresh_f9025') && plan
				? `/jira/plans/${plan.planId}/scenarios/${plan.scenarioId}${page}`
				: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${page}`;

		if (newUrl === location.pathname) {
			// short-circuit if the redirect url is the same
			return;
		}
		replace(newUrl);
	};
};

const withRedirectToSpaPlanPage =
	<P extends object>(
		WrappedComponent: ComponentType<P>,
	): ((props: P) => ReactElement<P & RedirectProps>) =>
	(props: P) => {
		const redirectToSpaPlanPage = useRedirectToSpaPlanPage();
		return <WrappedComponent {...props} redirectToSpaPlanPage={redirectToSpaPlanPage} />;
	};

export default withRedirectToSpaPlanPage;
